import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-ef05df3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "m-note-progress"
}
const _hoisted_2 = { class: "m-progress-wrap" }
const _hoisted_3 = { class: "u-node-desc" }
const _hoisted_4 = {
  key: 1,
  class: "m-progress-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!$props.status && $setup.progressList?.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.progressList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["m-flex-item", {firstItem: index === 0, lastItem: index === $setup.progressList.length - 1}]),
              key: `m-step-${index}`
            }, [
              index
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["u-delimiter", {doneDelimiter: ['done', 'fail', 'pendding'].includes(item?.status || ''), todoDelimiter: item?.status === 'todo'}])
                  }, null, 2))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(["u-node", {firstNode: index === 0, lastNode: index === $setup.progressList.length - 1, doneNode: item?.status === 'done', failNode: item?.status === 'fail', penddingNode: item?.status === 'pendding', todoNode: item?.status === 'todo'}])
              }, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(item.desc), 1)
              ], 2)
            ], 2))
          }), 128))
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($setup.progressText), 1))
}